import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../services/common.service';


@Component({
  selector: 'app-compe-coll-tva',
  templateUrl: './compe-coll-tva.component.html',
  styleUrls: ['./compe-coll-tva.component.css']
})
export class CompeCollTvaComponent implements OnInit {
  @Input() sansZero: Boolean = false;
  @Input() detail;
  @Input()
  set setArticle(val: any) {
    this.client = val;
    const listTVA = this.common.getType('listTVA') || [];
    this.listeComptesArticleParTVA = [];
    listTVA.forEach(l => {
      if (l.id !== 0) {
        let compteCollectif = '';
        if (this.client.listeCompteCollectifParTVA) {
          this.client.listeCompteCollectifParTVA.forEach(al => {
            if (al.tva && al.tva.id === l.id) {
              compteCollectif = al.compteCollectif || '';
            }
          });
        }

        this.listeComptesArticleParTVA.push({ compteCollectif: compteCollectif, tva: l, nomclass: 'CompteCollectifParTVA' });

      }
    });
  }
  public client: any = {}; // l'objet principal
  public rowSelect: any = {};
  public loadingIndicator: Boolean = false;
  public listeComptesArticleParTVA = [];

  @Output() public callback: EventEmitter<any> = new EventEmitter<any>();



  constructor(public common: CommonService) {

  }

  ngOnInit() {
  }

  showInput(index?) {
    const ctrl = this;
  }

  annuler() {
    this.callback.emit();
  }

  save() {
    const ctrl = this;

    this.client.listeCompteCollectifParTVA = this.listeComptesArticleParTVA;
    this.callback.emit();
  }
}
